import React from "react";
import styles from "./warnings.module.scss";

export const InputWarning = ({ children, nowrap }: {children?: any, nowrap?: boolean}) => {
  return <label className={`${styles.error} ${nowrap ? styles.error__nowrap : ''}`}>{children}</label>;
};
